var _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31960c",
    d: "M511.985 1010.526c-274.89 0-498.526-223.636-498.526-498.526s223.636-498.526 498.526-498.526c274.89 0 498.524 223.637 498.524 498.526s-223.634 498.526-498.524 498.526z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#20a6d2",
    d: "M0 512c0-282.759 229.241-512 512-512s512 229.241 512 512c0 282.759-229.241 512-512 512s-512-229.241-512-512zM997.052 512c0-267.453-217.599-485.053-485.052-485.053s-485.053 217.6-485.053 485.053c0 267.453 217.6 485.052 485.053 485.052s485.052-217.599 485.052-485.052z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M404.875 728.119l-186.125-186.126 57.182-57.155 128.943 128.943 325.875-325.874 57.182 57.155-383.057 383.057z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckGreen);
export default __webpack_public_path__ + "static/media/circle-check-green.cda865e8c9a27f2501efe35d2e0519b6.svg";
export { ForwardRef as ReactComponent };